// @flow
import EnterpriseTitle from './EnterpriseTitle';

export default EnterpriseTitle;
